import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { SearchModule } from '../../../shared/components/search/search.module';
import { AircraftSearchComponent } from './aircraft-search.component';
import { AircraftSearchService } from './aircraft-search.service';
import { CustomerSearchBarModule } from '../../../shared/components/customer-searchbar/customer-search-bar.module';
import { AircraftSharedModule } from '../shared/aircraft-shared.module';
import { SharedModule } from 'primeng/api';
import { SharedPipesModule } from '@max/shared/pipes/shared-pipes.module';

@NgModule({
    declarations: [
        AircraftSearchComponent,
    ],
    providers: [
        AircraftSearchService
    ],
    imports: [
        CommonModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        SharedModule,
        SharedPipesModule,
        SearchModule,
        TableModule,
        AircraftSharedModule,
        CustomerSearchBarModule
    ],
    exports: [
        AircraftSearchComponent,
    ]
})
export class AircraftSearchModule {}
